export default __webpack_public_path__ + "static/media/agent-console-logo.a913cd97.svg";